import '@/styles/themes/ror.scss'
import '@/styles/base.scss'
import { createApp } from 'vue'
import { VueQueryPlugin } from '@tanstack/vue-query'
import { vReveal } from '@/shared/directives/reveal'
import App from './App.vue'

createApp(App).use(VueQueryPlugin).directive('reveal', vReveal).mount('#app')
